import React from 'react'
import { Select, Input, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-haitao.module.less'
import DateChoose from '@/compenents/dateChoose'
import BasicInformation from './basic-information'
import CooperationPolicy from './cooperation-policy'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class MedicalEquipmentnHaitaoDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      postData: {
        item_id: 1
      },
      detailsData: null,
    }
  }

  componentDidMount () {
    let {postData} = this.state
    if (getParmUrl('id')) {
      postData.item_id = getParmUrl('id')
      this.setState({
        postData,

      }, () => {
        this.getBasicDetails()
      })
    }
  }

  // 获取详情
  getBasicDetails = async () => {
    let {postData, detailsData} = this.state
    try {
      let res = await ajaxApi({
        url:common.scpUrl + 'item/query-detail',
        params: postData
      })
      if (res.status === 200 && res.data) {
        this.setState({
          detailsData: res.data
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  render () {
    return (
      <div className="addGood">
        <div className="search">
          <div style={{position: 'relative'}}>
            <Button shape="round" type='primary' style={{position: 'absolute', top: '1%', right: '0%', zIndex: 1, display: getParmUrl('status') === 'pass_check' ? 'none' : 'inline-block'}}><a href= {'/main/commoditymanagement/addcompleteinformation/medicalequipmentnhaitao/medical-equipmentn-haitao?type=edit&&id=' + getParmUrl('id')} target = '_blank'>编辑</a></Button>
            <Tabs defaultActiveKey="1" onChange={this.callback}>
              <TabPane tab="商品信息" key="1">
                <BasicInformation detailsData = {this.state.detailsData}/>
              </TabPane>
              <TabPane tab="合作信息" key="2">
                <CooperationPolicy detailsData = {this.state.detailsData}/>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    )
  }
}
export default MedicalEquipmentnHaitaoDetails



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnhaitaodetails/medical-equipmentn-haitao-details.js